import { parseNotificationMessageMarkdown } from './parseNotificationMessageMarkdown'

export { parseNotificationMessageMarkdown }
export default { parseNotificationMessageMarkdown }
